module.exports = __webpack_public_path__ + "img/setting.fd3802b7.svg";